<template>
  <div class="product-detail">
    <div class="defult_width">
      <div class="location">{{language === 'E' ? 'Location：' : '当前位置：'}}<router-link to="/ProductCenter">{{language === 'E' ? 'Product Center' : '产品中心'}}</router-link> > <span>{{ detail.current.title }}</span></div>
      <el-row :gutter="20">
        <el-col :span="8">
           <el-menu
            :default-active="`${$route.params.index}-${$route.params.id}`"
            class="el-menu-vertical-demo"
            :unique-opened="true"
            @open="handleOpen">
            <el-submenu v-for="(item,index) in productList.product" :index="index+''" :key="index">
              <template slot="title">
                <span>{{item.label}}</span>
              </template>
              <el-menu-item v-for="li in item.list" :key="li.id+''" :index="`${index}-${li.id}`">
                <router-link :to="`/productDetail/${li.id}/${item.type}`">
                {{li.title}}
                </router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
        <el-col :span="16">
          <div class="left">
              <h5>{{ detail.current.title }}</h5>
              <!-- <div class="time">发布时间：{{ detail.current.time.year + '/' + detail.current.time.month}}</div> -->
              <!-- <img :src="detail.current.img" alt=""> -->
              <div v-for="(item, key) in detail.current.html" :key="key">
                <img v-if="item.img" :src="item.img"  alt="">
                <el-table v-else-if="item.table && item.table.tableData" :header-cell-style="{fontSize: item.table.thFontSize+'px',color: item.table.thcolor,background: item.table.thbackground }" size="medium" :data="item.table.tableData" border header-row-class-name="table-box">
                 <template v-for="(col,k) in item.table.cols">
                    <el-table-column
                        :key="k"
                        :show-overflow-tooltip="col.key !== 'operation' && !col.overflow"
                        :align="col.align || 'center'"
                        :width="col.width || 'auto'"
                        :label="col.label"
                    >
                        <template slot-scope="{$index,row}">
                          <div :style="`font-size: ${col.tdFontSize || item.table.tdFontSize}px;color: ${col.tdcolor || item.table.tdcolor};`">{{row[col.key] || '-'}}</div>
                        </template>
                    </el-table-column>
                </template>
               </el-table>
                <h6 v-else-if="item.title">{{ item.title }}</h6>
                <p v-else v-html="item">
                </p>
              </div>

            </div>
          </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import productList from '@/datas/productList'
import EproductList from '@/EnglishData/productList'
export default {
  name: 'ProductCenter',
  data () {
    const language = localStorage.getItem('language')
    let languageProductList = null
    if (language && language === 'E') {
      languageProductList = EproductList
    } else {
      languageProductList = productList
    }
    return {
      productList: languageProductList,
      detail: null,
      productIndex: 0,
      language
    }
  },
  created () {
    const { product } = productList
    let next = null; let pre = null
    let id = parseInt(this.$route.params.id)
    let index = parseInt(this.$route.params.index)
    next = (id - 0) === 1 ? product[index].list.length : (id - 0) - 1
    pre = (id - 0) === product[index].list.length ? 1 : (id - 0) + 1
    let list = { current: null, preDetail: null, nextDetail: null }
    product[index].list.forEach((item) => {
      if (item.id === id) {
        list.current = item
      }
      if (item.id === next) {
        list.nextDetail = item
      }
      if (item.id === pre) {
        list.preDetail = item
      }
    })
    this.detail = list
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>
<style lang="less" scoped>
.product-detail {
  padding: 0 0 50px;
  border-top: 1px solid #e5e5e5;
  background: #f9f9f9;
  overflow: hidden;
  .location {
    padding: 20px 0;
    text-align: left;
    a {
      color: #333;
    }
  }

  .el-submenu__title {
    background: #f9f8fa !important;
    span {
      color: #1e50ae;
      font-size: 18px;
      padding-left: 12px;
    }
  }
  .el-menu {
    border-right: 0;
    text-align: left;
    .el-menu-item {
        padding: 0;
    }
    a {
      color: #333;
      display: block;
    }
    .is-active {

      .router-link-active {
        color: #1e50ae;
        border-right: 2px solid #1e50ae;
        font-weight: 800;
      }
    }
  }
  .left {
    // width: 65%;
    // margin-right: 5%;
    // float: left;
    // text-align: center;
    h5 {
      font-size: 20px;
      color: 000;
      line-height: 40px;
      font-weight: 800;
      margin-bottom: 30px;
    }
    h6 {
      font-size: 16px;
      color: 222;
      padding: 10px 0;
      margin-bottom: 10px;
    }
    .time {
      text-align: right;
      color: #888;
      margin: 10px 0 20px;
    }
    p {
      text-align: left;
      line-height: 30px;
      text-indent: 2em;
      margin-bottom: 20px;
    }
    img {
      margin: 0 auto;
      max-width: 100%;
      margin-bottom: 20px;
    }
  }
  .right {
    width: 30%;
    float: right;
    text-align: left;
    .describe {
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      p {
        margin-top: 20px;
        &:last-child {
          text-align: right;
        }
      }
    }
    .right-title {
      font-size: 18px;
      padding-bottom: 15px;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      &::after {
        position: absolute;
        content: ' ';
        display: block;
        left: 0;
        bottom: -2px;
        width: 45px;
        height: 4px;
        background: #1e50ae;
      }
    }
    .list-box {
      margin-top: 20px;
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      li {
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #e5e5e5;
          text-align: center;
          img {
            width: 50%;
          }
          h5 {
            font-size: 16px;
            line-height: 30px;
            color: #1e50ae;
          }
          p {
            font-size: 14px;
            line-height: 24px;
          }
        }
        &:last-child {
          a {
            border: none;
          }
        }
      }
    }
  }

  /deep/ .table-box {
    background-color: #ff0;
    th {
      font-weight: 800;
      font-size: 15px;
      color: #555;
      background-color: #f4f4f4;
    }
  }
}
*/deep/ .el-table--border {
  border-color: #6a6a6a;
  td,th {
    border-color: #acacac;
  }
  &::after {
    background-color:#6a6a6a;
  }
  &::before {
    background-color: #6a6a6a;
  }
}
.el-submenu.is-active {
  .el-submenu__title {
    background-color: #f9f8fa;
  }
}
.el-table {
  margin-bottom: 10px;
}
*/deep/.el-table .cell.el-tooltip {
  white-space: inherit;
}

</style>



// WEBPACK FOOTER //
// src/view/product/detail.vue